module.exports = __webpack_public_path__ + "img/gongren.2e191f64.png";